import { Skeleton } from "components/ui/skeleton";

export default function SkeletonMusicLibrariesCard() {
  return (
    <>
      <div className="rounded-md me-2 p-2 w-full border h-full">
        <div className="flex items-center gap-3 h-full">
          <div className="">
            <div className="flex justify-center items-center w-full h-full rounded-tl-md rounded-bl-md">
              <Skeleton className="w-16 h-16 rounded-tl-md rounded-bl-md" />
            </div>
          </div>

          {/* Sound Details */}
          <div className="flex-1 space-y-2">
            <Skeleton className="w-full h-3" />
            <div className="flex justify-between w-full">
              <div className="flex space-x-3">
                <Skeleton className="w-6 h-2" />
                <Skeleton className="w-6 h-2" />
                <Skeleton className="w-6 h-2" />
              </div>
              <Skeleton className="w-8 h-4" />
            </div>

            <div className="flex justify-between">
              <div className="flex space-x-2 items-center">
                <Skeleton className={`h-6 w-6 rounded-full`} />

                <Skeleton className={`w-10 h-5 rounded-md`} />
                <Skeleton className={`w-10 h-5 rounded-md`} />
              </div>
              <div>
                <Skeleton className="w-10 h-5 rounded-md" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
